import Constants from '@/utils/Constants'
import Errors from '@/utils/Errors'

const state = {
  active: false,

  title: 'エラー',
  body: '',
  label: '閉じる',

  // 個別処理モード
  mode: Errors.Mode.Default
}

const getters = {
  get: state => state
}

const actions = {
  show ({commit}, error) {
    // console.log('routeName:', this.state.route.name)

    // cover
    this.dispatch('core/showDialogCover')

    let parameters = {}

    // アプリケーションエラー表示
    if (error === null) {
      parameters.title = Errors.AppErrorMessage.title
      parameters.body = Errors.AppErrorMessage.body

    // エラーメッセージ表示
    } else {
      // 新API仕様
      let errorCodeList = []
      let message = []

      // エラーメッセージの作成
      error
        .filter(item => item.status === Errors.Status.Failure)
        .forEach(item => {
          if (item.data.errors) {
            item.data.errors.forEach(err => {
              if (errorCodeList.indexOf(err.code) === -1) {
                errorCodeList.push(err.code)
                message.push(err.message + '（' + err.code + '）')
              }
            })
          }
        })
      parameters.body = message.join('<br>')

      // E4002 : アクセストークン認証が失敗しました
      // E4004 : ユーザ認証情報は正しくありません
      if (errorCodeList.indexOf('E4002') !== -1 ||
        errorCodeList.indexOf('E4004') !== -1) {
        commit('setMode', Errors.Mode.InvalidAuth)
      }

      // E4003 : アクセストークンの有効期限が切れました
      if (errorCodeList.indexOf('E4003') !== -1) {
        commit('setMode', Errors.Mode.TokenExpired)
      }
    }

    commit('showed', parameters)
  },
  hide ({commit}) {
    if (!state.active) return
    commit('hided')
    
    // cover
    setTimeout(() => {
      this.dispatch('core/hideDialogCover')
    }, 350)
  }
}

const mutations = {
  showed (state, {title, body, label}) {
    if (title !== undefined) state.title = title
    if (body !== undefined) state.body = body
    if (label !== undefined) state.label = label
    state.active = true
  },
  hided (state) {
    state.active = false
    state.title = ''
    state.body = ''
    state.label = ''
    state.mode = Errors.Mode.Default
  },

  // モード変更
  setMode (state, mode) {
    state.mode = mode
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
